// extracted by mini-css-extract-plugin
export default {"Page":"dVyCEwf6LnENG1r267DQ"};